'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useAudioPlayer = function useAudioPlayer(audioRef, progressBarRef, volumeCtrl) {
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useState3 = React.useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    duration = _useState4[0],
    setDuration = _useState4[1];
  var _useState5 = React.useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentTime = _useState6[0],
    setCurrentTime = _useState6[1];
  var _useState7 = React.useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFinishedPlaying = _useState8[0],
    setIsFinishedPlaying = _useState8[1];
  var animationRef = React.useRef(); // reference the animation
  var _useState9 = React.useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isMuted = _useState10[0],
    setIsMuted = _useState10[1];
  var isStream = audioRef.current && audioRef.current.currentSrc.includes('stream');
  React.useEffect(function () {
    if (currentTime === Number(duration)) {
      // restart()
      setIsFinishedPlaying(true);
    }
  }, [currentTime]);
  var onLoadedMetadata = function onLoadedMetadata() {
    var _audioRef$current;
    var seconds = Math.floor(audioRef.current.duration);
    setDuration(seconds);
    if (!(audioRef !== null && audioRef !== void 0 && (_audioRef$current = audioRef.current) !== null && _audioRef$current !== void 0 && _audioRef$current.currentSrc.includes('stream'))) {
      progressBarRef.current.max = seconds;
    }
  };
  var updateCurrentTime = function updateCurrentTime() {
    setCurrentTime(progressBarRef.current.value);
  };
  var whilePlaying = function whilePlaying() {
    var _audioRef$current2;
    if (!(audioRef !== null && audioRef !== void 0 && (_audioRef$current2 = audioRef.current) !== null && _audioRef$current2 !== void 0 && _audioRef$current2.currentSrc.includes('stream'))) {
      // isStream isn't correct here

      progressBarRef.current.value = Math.floor(audioRef.current.currentTime);
    }
    progressBarRef.current.style.setProperty('--seek-before-width', "".concat(progressBarRef.current.value / duration * 100, "%"));
    updateCurrentTime();

    // when you reach the end of the song
    if (!isStream && progressBarRef.current.value === duration) {
      // restart()
      setIsFinishedPlaying(true);
      return;
    }
    animationRef.current = window.requestAnimationFrame(whilePlaying);
  };
  var pause = function pause() {
    setIsPlaying(false);
    audioRef.current.pause();
    window.cancelAnimationFrame(animationRef.current);
  };

  // const restart = () => {
  //   progressBarRef.current.value = 0
  //   updateCurrentTime()
  //   pause()
  // }

  var play = function play() {
    setIsPlaying(true);
    setIsFinishedPlaying(false);
    audioRef.current.play();
    if (!audioRef.current.currentSrc.includes('stream')) {
      // isStream isn't correctly set here
      animationRef.current = window.requestAnimationFrame(whilePlaying);
    }
  };
  var toggleMute = function toggleMute() {
    setIsMuted(!isMuted);
  };
  var calculateTime = function calculateTime(secs) {
    var minutes = Math.floor(secs / 60);
    var returnedMinutes = minutes < 10 ? "0".concat(minutes) : "".concat(minutes);
    var seconds = Math.floor(secs % 60);
    var returnedSeconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
    return "".concat(returnedMinutes, ":").concat(returnedSeconds);
  };
  var togglePlaying = function togglePlaying() {
    if (!isPlaying) {
      play();
    } else {
      pause();
    }
  };
  var changePlayerCurrentTime = function changePlayerCurrentTime() {
    audioRef.current.currentTime = progressBarRef.current.value;
    setCurrentTime(progressBarRef.current.value);
    progressBarRef.current.style.setProperty('--seek-before-width', "".concat(progressBarRef.current.value / duration * 100, "%"));
  };
  var changeRange = function changeRange() {
    audioRef.current.currentTime = progressBarRef.current.value;
    updateCurrentTime();
    changePlayerCurrentTime();
  };
  var rewindControl = function rewindControl() {
    progressBarRef.current.value = Number(progressBarRef.current.value) - 15;
    changeRange();
  };
  var forwardControl = function forwardControl() {
    progressBarRef.current.value = Number(progressBarRef.current.value) + 15;
    changeRange();
  };
  var volumeControl = function volumeControl(e) {
    var value = e.target.value;
    var volume = value / 100;
    audioRef.current.volume = volume;
  };
  var formatCalculateTime = function formatCalculateTime(timeString) {
    var toString = String(timeString);
    if (toString.split(':').length === 3) {
      var _toString$split = toString.split(':'),
        _toString$split2 = _slicedToArray(_toString$split, 3),
        hours = _toString$split2[0],
        minutes = _toString$split2[1],
        seconds = _toString$split2[2];
      return "".concat(parseInt(hours), "hr ").concat(parseInt(minutes), "min ").concat(parseInt(seconds), "sec");
    } else if (toString.split(':').length === 2) {
      var _toString$split3 = toString.split(':'),
        _toString$split4 = _slicedToArray(_toString$split3, 2),
        _minutes = _toString$split4[0],
        _seconds = _toString$split4[1];
      return "".concat(parseInt(_minutes), "min ").concat(parseInt(_seconds), "sec");
    }
  };
  return {
    onLoadedMetadata: onLoadedMetadata,
    calculateTime: calculateTime,
    togglePlaying: togglePlaying,
    changePlayerCurrentTime: changePlayerCurrentTime,
    rewindControl: rewindControl,
    forwardControl: forwardControl,
    play: play,
    pause: pause,
    isPlaying: isPlaying,
    isFinishedPlaying: isFinishedPlaying,
    currentTime: currentTime,
    duration: duration,
    volumeCtrl: volumeCtrl,
    isMuted: isMuted,
    volumeControl: volumeControl,
    toggleMute: toggleMute,
    formatCalculateTime: formatCalculateTime
  };
};

var Play = function Play() {
  return /*#__PURE__*/React__default.createElement("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 448 512",
    className: "play",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": "play playButton"
  }, /*#__PURE__*/React__default.createElement("title", {
    id: "play"
  }, "Play"), /*#__PURE__*/React__default.createElement("desc", {
    id: "playButton"
  }, "Play Button"), /*#__PURE__*/React__default.createElement("path", {
    d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
  }));
};

var Pause = function Pause() {
  return /*#__PURE__*/React__default.createElement("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 448 512",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": "pause pauseButton"
  }, /*#__PURE__*/React__default.createElement("title", {
    id: "pause"
  }, "Pause"), /*#__PURE__*/React__default.createElement("desc", {
    id: "pauseButton"
  }, "Pause Button"), /*#__PURE__*/React__default.createElement("path", {
    d: "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
  }));
};

var ReactAudioPlayerInner = function ReactAudioPlayerInner(props) {
  var _props$audioPlayerRef, _props$progressBarRef;
  // references
  var audioPlayerRef = (_props$audioPlayerRef = props.audioPlayerRef) !== null && _props$audioPlayerRef !== void 0 ? _props$audioPlayerRef : React.useRef(); // reference our audio component
  var progressBarRef = (_props$progressBarRef = props.progressBarRef) !== null && _props$progressBarRef !== void 0 ? _props$progressBarRef : React.useRef(); // reference our progress bar

  var customStyles = props ? props.style : '';
  var title = props.title,
    audioSrc = props.audioSrc,
    volumeCtrl = props.volumeCtrl,
    playBtnClass = props.playBtnClass,
    customHtml = props.customHtml,
    isLive = props.isLive,
    onLoadedMetadata = props.onLoadedMetadata,
    calculateTime = props.calculateTime,
    togglePlaying = props.togglePlaying,
    changePlayerCurrentTime = props.changePlayerCurrentTime,
    isPlaying = props.isPlaying,
    currentTime = props.currentTime,
    duration = props.duration,
    volumeControl = props.volumeControl,
    toggleMute = props.toggleMute,
    isMuted = props.isMuted,
    formatCalculateTime = props.formatCalculateTime,
    rewindControl = props.rewindControl,
    forwardControl = props.forwardControl;
  var audioDuration = duration && !isNaN(duration) && calculateTime(duration);
  var formatDuration = duration && !isNaN(duration) && audioDuration && formatCalculateTime(audioDuration);
  return audioSrc && /*#__PURE__*/React__default.createElement("div", {
    className: "audioPlayer",
    style: customStyles && customStyles.audioPlayer
  }, /*#__PURE__*/React__default.createElement("audio", {
    ref: audioPlayerRef,
    src: audioSrc,
    preload: "none",
    onLoadedMetadata: onLoadedMetadata,
    muted: isMuted
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "player-layout"
  }, volumeCtrl && /*#__PURE__*/React__default.createElement("div", {
    className: "player-controls-secondary-outer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "player-volume-control"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "player-volume-icon"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: toggleMute,
    "aria-label": isMuted === true ? 'Muted' : 'Not Muted',
    title: isMuted === true ? 'Muted' : 'Not Muted'
  }, !isMuted ? /*#__PURE__*/React__default.createElement("img", {
    src: "/img/icon-volume-low.svg",
    alt: "Volume Button"
  }) : /*#__PURE__*/React__default.createElement("img", {
    src: "/img/icon-volume-mute.svg",
    alt: "Volume Mute Button"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "player-timeline player-controls-secondary"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "player-volume",
    type: "range",
    className: "player-volume-progress",
    min: 0,
    max: 100,
    "aria-hidden": "true",
    "aria-valuetext": "100%",
    onChange: function onChange(e) {
      return volumeControl(e);
    }
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    src: "/img/icon-volume-high.svg",
    alt: "Volume Button"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "player-volume-label"
  }, "Volume")), /*#__PURE__*/React__default.createElement("div", {
    className: "player-controls"
  }, !isLive && /*#__PURE__*/React__default.createElement("div", {
    className: "player-backward-forward-controls"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: rewindControl
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "/img/icon-rewind-15.svg",
    alt: "Backward 15 seconds"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(isPlaying ? 'is-playing' : '', " player-btn-play-pause-outer")
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: togglePlaying,
    className: playBtnClass,
    style: customStyles && customStyles.playPause,
    id: "playbutton"
  }, isPlaying ? /*#__PURE__*/React__default.createElement(Pause, null) : /*#__PURE__*/React__default.createElement(Play, null))), !isLive && /*#__PURE__*/React__default.createElement("div", {
    className: "player-backward-forward-controls"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: forwardControl
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "/img/icon-forward-15.svg",
    alt: "Forward 15 seconds"
  })))), !isLive && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "player-timeline"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "player-timeline-progress-outer"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "range",
    className: "player-timeline-progress",
    defaultValue: "0",
    ref: progressBarRef,
    onChange: changePlayerCurrentTime,
    "aria-label": "Audio progress",
    max: duration
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "player-times"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "player-currentTime"
  }, calculateTime(currentTime)), /*#__PURE__*/React__default.createElement("div", {
    className: "player-duration",
    style: customStyles && customStyles.duration
  }, duration && !isNaN(duration) && calculateTime(duration))))), /*#__PURE__*/React__default.createElement("div", {
    className: "player-content"
  }, customHtml && customHtml, /*#__PURE__*/React__default.createElement("div", {
    className: "player-audio-type type-sm"
  }, isLive ? /*#__PURE__*/React__default.createElement("div", {
    className: "player-live-label"
  }, "On Air") : /*#__PURE__*/React__default.createElement("div", {
    className: "player-label"
  }, "listen", /*#__PURE__*/React__default.createElement("div", {
    className: "player-label-duration"
  }, "[".concat(formatDuration, "]"))), /*#__PURE__*/React__default.createElement("div", {
    className: "player-title"
  }, title || '', " ")))));
};

var ReactAudioPlayer = function ReactAudioPlayer(props) {
  var _props$audioPlayerRef, _props$progressBarRef;
  // references
  var audioPlayerRef = (_props$audioPlayerRef = props.audioPlayerRef) !== null && _props$audioPlayerRef !== void 0 ? _props$audioPlayerRef : React.useRef(); // reference our audio component
  var progressBarRef = (_props$progressBarRef = props.progressBarRef) !== null && _props$progressBarRef !== void 0 ? _props$progressBarRef : React.useRef(); // reference our progress bar

  var customStyles = props ? props.style : '';

  // hooks
  var _useAudioPlayer = useAudioPlayer(audioPlayerRef, progressBarRef),
    isPlaying = _useAudioPlayer.isPlaying,
    currentTime = _useAudioPlayer.currentTime,
    duration = _useAudioPlayer.duration,
    isMuted = _useAudioPlayer.isMuted,
    onLoadedMetadata = _useAudioPlayer.onLoadedMetadata,
    calculateTime = _useAudioPlayer.calculateTime,
    togglePlaying = _useAudioPlayer.togglePlaying,
    changePlayerCurrentTime = _useAudioPlayer.changePlayerCurrentTime,
    volumeControl = _useAudioPlayer.volumeControl,
    toggleMute = _useAudioPlayer.toggleMute,
    formatCalculateTime = _useAudioPlayer.formatCalculateTime,
    rewindControl = _useAudioPlayer.rewindControl,
    forwardControl = _useAudioPlayer.forwardControl;
  return /*#__PURE__*/React__default.createElement(ReactAudioPlayerInner, _extends({}, props, {
    audioPlayerRef: audioPlayerRef,
    progressBarRef: progressBarRef,
    isPlaying: isPlaying,
    isMuted: isMuted,
    currentTime: currentTime,
    duration: duration,
    customStyles: customStyles,
    onLoadedMetadata: onLoadedMetadata,
    calculateTime: calculateTime,
    togglePlaying: togglePlaying,
    changePlayerCurrentTime: changePlayerCurrentTime,
    volumeControl: volumeControl,
    toggleMute: toggleMute,
    formatCalculateTime: formatCalculateTime,
    rewindControl: rewindControl,
    forwardControl: forwardControl
  }));
};

exports.ReactAudioPlayer = ReactAudioPlayer;
exports.ReactAudioPlayerInner = ReactAudioPlayerInner;
exports.useAudioPlayer = useAudioPlayer;
